var React = require('react');

function SendWhatsapp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M2.01 21L23 12 2.01 3 2 10l15 2-15 2z","key":1})]);
}

SendWhatsapp.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = SendWhatsapp;

SendWhatsapp.default = SendWhatsapp;
